<template>
  <v-dialog v-model="show" :persistent="loading" @close="close" max-width="500">
    <v-card :loading="loading" rounded="lg">
      <div class="pa-4">
        <h5>Aprovar solicitação</h5>
        <v-list>
          <v-list-item v-for="item in itemsList" :key="item.id">
            <v-list-item-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-1">
              <v-list-item-title class="font-weight-bold">
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-body-2 font-weight-medium">
                {{ item.total | currency }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="mb-4" />

        <!-- Total da despesa que será do evento -->
        <h6 class="mb-0">Divisão da despesa</h6>
        <span class="d-block mb-2"> Defina a central de custo dessa SR </span>
        <v-btn-toggle
          v-model="selectedDivision"
          mandatory
          color="primary"
          class="w-full"
        >
          <v-btn value="event" class="flex-1" small> Evento </v-btn>
          <v-btn value="mixed" class="flex-1" small> Divisão </v-btn>
          <v-btn value="company" class="flex-1" small> Empresa </v-btn>
        </v-btn-toggle>
        <v-card v-if="selectedDivision === 'mixed'" class="mt-4 pa-4" outlined>
          <v-text-field
            v-model="partyTotalDebit"
            label="O evento pagará"
            hide-details
            outlined
            dense
            prefix="R$"
            :suffix="(parsedPartyTotalDebit / total) | percentage(0)"
            type="number"
            :max="total"
            :rules="[
              (v) => v <= total || 'O valor máximo é o total da despesa',
            ]"
          />
          <v-divider class="my-4" />
          <v-text-field
            label="A empresa pagará"
            :value="total - parsedPartyTotalDebit"
            hide-details
            outlined
            disabled
            prefix="R$"
            :suffix="((total - parsedPartyTotalDebit) / total) | percentage(0)"
            dense
          />
        </v-card>

        <v-alert v-if="error" type="error" class="mt-4 mb-0">
          {{ error }}
        </v-alert>
        <div class="d-flex align-center gap-2 mt-4">
          <v-btn text @click="close" :disabled="loading"> Cancelar </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="approve"
            :disabled="
              loading ||
              parsedPartyTotalDebit < 0 ||
              parsedPartyTotalDebit > total
            "
          >
            Enviar
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import RESOURCE_REQUEST from "@/services/admin/resourceRequest";
import MyBankAccountSelector from "@/components/global/selector/MyBankAccountSelector.vue";

export default {
  name: "ResourceRequestAproveModal",
  components: {
    MyBankAccountSelector,
  },

  props: {
    types: {
      type: Object,
      required: true,
    },
    itens: {
      type: Array | Boolean,
      required: true,
    },
    resourceRequest: {
      type: Object | null,
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      error: null,
      selectedDivision: "event",
      partyTotalDebit: 0,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async approve() {
      try {
        this.loading = true;
        this.error = null;
        await RESOURCE_REQUEST.approve(this.resourceRequest.id, {
          partyTotalDebit: this.parsedPartyTotalDebit,
        });

        this.$emit("success");
        this.close();
      } catch (e) {
        this.error = e.message || "Erro ao enviar solicitação de recurso";
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    selectedDivision(newVal) {
      if (newVal === "mixed") {
        this.partyTotalDebit = this.total * 0.5;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    itemsList() {
      if (!this.itens) return [];
      const grouped = this.itens.reduce((acc, item) => {
        acc[item.type] = acc[item.type] || {
          ...this.types[item.type],
          total: 0,
        };

        acc[item.type].total += item.amount;
        return acc;
      }, {});
      return Object.values(grouped);
    },
    total() {
      return this.itemsList.reduce((acc, item) => acc + item.total, 0);
    },
    parsedPartyTotalDebit() {
      if (this.selectedDivision === "event") return this.total;
      if (this.selectedDivision === "company") return 0;

      if (!this.partyTotalDebit) return 0;
      return parseFloat(`${this.partyTotalDebit}`.replace(",", "."));
    },
  },
  mounted() {
    this.$parent.$on("approve-resource-request", this.open);
  },
};
</script>
